import { Heading } from '../base/heading'
import { Divider } from '../base/divider'
import { IntegrationProviderCategoriesQuery } from './__generated__/collection_query'
import { Button } from '../base/button'
import { Query as CollectionQuery } from './collection_query'
import { Mutation as CreateMutation } from './create_integration_mutation'
import { CreateIntegrationMutation } from './__generated__/create_integration_mutation'
import { useForm } from '@/helpers/useForm'
import { IntegrationAttributes } from '@/types'
import { DeleteDialog } from '../delete_dialog'
import { Mutation as DeleteMutation } from './delete_mutation'
import { useState } from 'react'

type IntegrationProvider = IntegrationProviderCategoriesQuery['integrationProviderCategories'][0]['integrationProviders'][0]

interface Props {
  integrationProvider: IntegrationProvider
}

export const Integration = ({ integrationProvider }: Props) => {
  const { displayName, image, description, integrations } = integrationProvider

  const [openDeleteQuickfile, setOpenDeleteQuickfile] = useState(false)

  const {
    setAttributes,
    save,
    saveSuccess,
    formBuilder,
    mutationLoading,
  } = useForm<CreateIntegrationMutation, IntegrationAttributes, never, never>({
    defaultValues: {
      integrationType: 'quickfile'
    },
    mutation: CreateMutation,
    resultKey: 'createIntegration',
    refetchQueries: [CollectionQuery]
  })

  const form = () => {
    switch (integrationProvider.__typename) {
      case 'IntegrationProvidersFreeagent':
        return (<>
          <Button color="green" href={integrationProvider.authorizeAppUrl}>Connect</Button>
        </>)
      case 'IntegrationProvidersXero':
        return (<>
          <Button color="green" href={integrationProvider.authorizeAppUrl}>Connect</Button>
        </>)
      case 'IntegrationProvidersQuickfile':
        return (<div className="flex flex-col gap-4">
          <div>
            { formBuilder.buildQueryError() }
          </div>
          <div className="flex flex-row gap-4 w-full">
            { formBuilder.buildField({ name: 'Token', field: 'quickfileToken', type: 'text' }) }
            { formBuilder.buildField({ name: 'Account number', field: 'quickfileAccountNumber', type: 'text' }) }
            { formBuilder.saveButton(saveQuickfile, mutationLoading, saveSuccess, 'Connect') }
          </div>
        </div>)
      case 'IntegrationProvidersMystro':
        return (<>
          <Button color="green" href={integrationProvider.authorizeAppUrl}>Connect</Button>
        </>)
      // case 'IntegrationProvidersGoogleCalendar':
      //   return (<>
      //     <Button color="green" href={integrationProvider.authorizeAppUrl}>Connect</Button>
      //   </>)
      default:
        return <></>
    }
  }

  const saveQuickfile = () => {
    setAttributes(attributes => ({ ...attributes, integrationType: 'quickfile' }))
    save()
  }

  return (
    <div>
      <div className="p-4 rounded-xl border border-zinc-700 bg-zinc-800 flex flex-col gap-4">
        <span className="flex flex-row gap-2 items-center justify-between">
          <Heading level={2}>{ displayName }</Heading>
          { image?.url && <img className="h-8 m-2" src={ image.url } /> }
        </span>
        { description && <>
          <Divider />
          <p className="py-2">{ description }</p>
        </> }
        <Divider />
        { integrations.length > 0
          ? <div>
            <DeleteDialog
              id={integrations[0].id}
              mutation={DeleteMutation}
              open={openDeleteQuickfile}
              refetchQueries={[CollectionQuery]}
              setOpen={setOpenDeleteQuickfile}
              onSuccess={() => { setOpenDeleteQuickfile(false) }}
            />
            <Button color="red" onClick={() => setOpenDeleteQuickfile(true)}>Disconnect</Button>
          </div>
          : <div>{ form() }</div> }
      </div>
    </div>
  )
}
